/**
 * Showing the numbers the database keeps.
 *
 * Quantities are stored with four decimal places because cable is measured in
 * metres and solder in grams. Pieces are not: "20.0000 шт" is four characters
 * of noise on every line of every screen, and the noise is worst exactly where
 * the numbers matter — a column of stock figures.
 *
 * The stored precision is never lost, only the trailing zeros that carry no
 * information: 1.5000 shows as 1.5, and 0.2500 as 0.25.
 */

/** A stored decimal, without the zeros that say nothing. */
export function num(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';
  const text = String(value).trim();
  if (!/^-?\d*\.?\d+$/.test(text)) return text;
  if (!text.includes('.')) return text;
  const trimmed = text.replace(/\.?0+$/, '');
  return trimmed === '' || trimmed === '-' ? '0' : trimmed;
}

/** A price or a total: the same trimming, plus the currency when there is one. */
export function money(
  value: string | number | null | undefined,
  currency?: string | null,
): string {
  const text = num(value);
  if (!text) return '';
  return currency ? `${text} ${currency}` : text;
}
